import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-one-why-choose',
  templateUrl: './sass-one-why-choose.component.html',
  styleUrls: ['./sass-one-why-choose.component.scss']
})
export class SassOneWhyChooseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
